<template>
	<div class="center_right">
		<div class="center_commNav">
			<div class="center_commNavItem" @click="activeName=item.id" :class="{'active':activeName==item.id}" v-for="(item,index) in commNavs">{{item.name}}</div>
		</div>
		<div v-show="activeName=='1'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="考试名称：">
							<el-input v-model="finiOnname" placeholder="请输入考试名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="考试状态：">
							<el-select :popper-append-to-body='false' v-model="finiOntypeId" placeholder="请选择考试状态" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>
						<br />
						<el-form-item label="考试时间：" class='form_big'>
							<el-date-picker v-model="finiOnTime" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOnCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOnFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOnlistData" border stripe>
					<emptymain slot='empty' :emptylist='finiOnlistData'></emptymain>
					<el-table-column label="考试名称" prop="name" align='center'></el-table-column>
					<el-table-column label="考试时间" align='center'>
						<template slot-scope="scope">
							{{scope.row.beginTime | spliceForTask}}
							<br /> -
							<br /> {{scope.row.endTime | spliceForTask}}
						</template>
					</el-table-column>
					<el-table-column label="考试时长" align='center'>
						<template slot-scope="scope">
							{{scope.row.timeSpent || '-'}}分钟
						</template>
					</el-table-column>
					<el-table-column label="考试状态" align='center'>
						<template slot-scope="scope">
							<span v-if='scope.row.state == 0' class='task_status'><img src="@/images/exam_status0.png"/>考试中</span>
							<span v-if='scope.row.state == 1' class='task_status'><img src="@/images/exam_status1.png"/>考试结束</span>
							<span v-if='scope.row.state == 2' class='task_status infoColor'><img src="@/images/exam_status2.png"/>考试异常</span>
							<span v-if='scope.row.state == 3' class='task_status infoColor'><img src="@/images/exam_status2.png"/>未参考</span>
						</template>
					</el-table-column>
					<el-table-column label="得分" prop="score" align='center'>
						<template slot-scope="scope">
							{{scope.row.score || '-'}}
						</template>
					</el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' v-if='scope.row.state == 0' @click="startexamine(scope.row)" :disabled="getDisabld(scope.row)">开始考试</el-button>
							<el-button plain size='medium' v-if='scope.row.state == 1' @click="examineit(scope.row)">查看详情</el-button>
							<span v-if='scope.row.state == 2' class='infoColor'>-</span>
							<el-button plain size='medium' v-if='scope.row.state == 3' @click="startexamine(scope.row)" :disabled="getDisabld(scope.row)">开始考试</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOnCurrentChange" :current-page="finiOncurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOntotal">
				</el-pagination>
			</div>
		</div>
		<div v-show="activeName=='2'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="考试名称：">
							<el-input v-model="finiOffname" placeholder="请输入考试名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="考试时间：" class='form_big'>
							<el-date-picker v-model="finiOffTime" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOffCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOffFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOfflistData" border stripe>
					<emptymain slot='empty' :emptylist='finiOfflistData'></emptymain>
					<el-table-column label="考试名称" prop="vrExamineName" align='center'></el-table-column>
					<el-table-column label="考试时间" align='center'>
						<template slot-scope="scope">
							{{scope.row.startTime | spliceForTask}}
							<br /> -
							<br /> {{scope.row.endTime | spliceForTask}}
						</template>
					</el-table-column>
					<el-table-column label="考试状态" align='center'>
						<template slot-scope="scope">
							{{getDisabldVrText(scope.row)}}
						</template>
					</el-table-column>
					<el-table-column label="及格分/总分" align='center'>
						<template slot-scope="scope">
							{{scope.row.passScore}}/{{scope.row.totalScore}}
						</template>
					</el-table-column>
					<el-table-column label="完成数/实验总数" align='center'>
						<template slot-scope="scope">
							{{scope.row.commitNumber}}/{{scope.row.extractNumber}}
						</template>
					</el-table-column>
					<el-table-column label="得分" align='center'>
						<template slot-scope="scope">
							<span>
								{{scope.row.score || '-'}}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' @click="startexamineVr(scope.row)">{{getDisabldVrBtn(scope.row)}}</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOffCurrentChange" :current-page="finiOffcurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOfftotal">
				</el-pagination>
			</div>
		</div>
		<el-dialog title="实验考试" class="open_dialogInfo" :visible.sync="examOpen" :append-to-body='true' width="1000px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<vrlist @startVrExam='startVrExam' v-if='examOpen' :vrExamineInfo='vrExamineInfo' :vrExamineId='vrExamineId'></vrlist>
		</el-dialog>
	</div>
</template>

<script>
	import { getLoginUserExamList } from '@/api/examine'
	import { vrExamineStudentList } from '@/api/vrExamUser.js'
	import vrlist from '@/views/examine/vrlist.vue'
	export default {
		components: {
			vrlist,
		},
		data() {
			return {
				activeName: '1',
				commNavs: [{
					name: '理论考试',
					id: '1'
				}, {
					name: '实验考试',
					id: '2'
				}],
				limit: 10,
				typeList: [{
					id: '0',
					name: '考试中'
				}, {
					id: '1',
					name: '考试结束'
				}, {
					id: '2',
					name: '考试异常'
				}, {
					id: '3',
					name: '未参考'
				}],
				states: [{
					id: '1',
					name: '已参考'
				}, {
					id: '2',
					name: '未参考'
				}],
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				//我的考试
				finiOnname: '',
				finiOntypeId: '',
				finiOnTime: '',
				finiOnlistData: [],
				finiOncurrent: 1,
				finiOntotal: 0,
				//实验考试
				finiOffname: '',
				finiOfftypeId: '',
				finiOffTime: '',
				finiOfflistData: [],
				finiOffcurrent: 1,
				finiOfftotal: 0,
				vrExamineId: '',
				vrExamineInfo: {},
				examOpen: false,
			};
		},
		created() {
			this.getfiniOnListData();
			this.getfiniOffListData();
		},
		mounted() {
			var that = this;
			window.onfocus = function() {
				that.getfiniOffListData();
			}
		},
		methods: {
			clearfiniOffFilter() {
				this.finiOffname = '';
				this.finiOfftypeId = '';
				this.finiOffTime = '';
				this.finiOffcurrent = 1
				this.getfiniOffListData();
			},
			getDisabldVrBtn(item) {
				var nowTime = new Date();
				var startTime = new Date(item.startTime);
				var endTime = new Date(item.endTime);
				if(nowTime < startTime) {
					return '未开始'
				}
				if(nowTime >= endTime) {
					return '查看详情'
				}
				if(nowTime >= startTime && nowTime < endTime) {
					if(item.commitNumber <= 0) {
						return '开始考试'
					} else {
						if(item.commitNumber < item.extractNumber) {
							return '继续考试'
						} else {
							return '查看详情'
						}
					}
				}
			},
			getDisabldVrText(item) {
				var nowTime = new Date();
				var startTime = new Date(item.startTime);
				var endTime = new Date(item.endTime);
				if(nowTime < startTime) {
					return '未开始'
				}
				if(nowTime >= endTime) {
					return '已结束'
				}
				if(nowTime >= startTime && nowTime < endTime) {
					return '进行中'
				}
			},
			startexamineVr(item) {
				this.vrExamineId = item.vrExamineId;
				this.vrExamineInfo = item;
				this.examOpen = true;
			},
			examineitVr(item) {
				this.vrExamineId = item.vrExamineId;
				this.vrExamineInfo = item;
				this.examOpen = true;
			},
			startVrExam() {
				this.vrExamineId = '';
				this.vrExamineInfo = {};
				this.examOpen = false;
			},
			finiOffCurrentChange(finiOffcurrent) {
				this.finiOffcurrent = finiOffcurrent;
				this.getfiniOffListData();
			},
			getfiniOffListData() {
				var data = {
					vrExamineName: this.finiOffname ? this.finiOffname : null,
					state: this.finiOfftypeId ? this.finiOfftypeId : null,
					startTime: this.finiOffTime ? this.finiOffTime[0] : null,
					endTime: this.finiOffTime ? this.finiOffTime[1] : null,
					current: this.finiOffcurrent,
					limit: this.limit,
				}
				vrExamineStudentList(data).then(res => {
					if(res.code == "OK") {
						this.finiOfflistData = res.data.records;
						this.finiOfftotal = res.data.total;
					}
				})
			},
			clearfiniOnFilter() {
				this.finiOnname = '';
				this.finiOntypeId = '';
				this.finiOnTime = '';
				this.finiOncurrent = 1
				this.getfiniOnListData();
			},
			finiOnCurrentChange(finiOncurrent) {
				this.finiOncurrent = finiOncurrent;
				this.getfiniOnListData();
			},
			getfiniOnListData() {
				var data = {
					examineName: this.finiOnname ? this.finiOnname : null,
					state: this.finiOntypeId ? this.finiOntypeId : null,
					beginTime: this.finiOnTime ? this.finiOnTime[0] : null,
					endTime: this.finiOnTime ? this.finiOnTime[1] : null,
					current: this.finiOncurrent,
					limit: this.limit,
				}
				getLoginUserExamList(data).then(res => {
					if(res.code == "OK") {
						this.finiOnlistData = res.data.records;
						this.finiOntotal = res.data.total;
					}
				})
			},
			getDisabld(item) {
				if(item.beginTime && item.endTime) {
					var nowTime = new Date();
					var beginTime = new Date(item.beginTime);
					var endTime = new Date(item.endTime);
					if(nowTime > beginTime && nowTime < endTime) {
						return false
					} else {
						return true
					}
				} else {
					return true
				}
			},
			startexamine(item) {
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime);
				var endTime = new Date(item.endTime);
				if(nowTime < beginTime) {
					this.$message({
						type: 'info',
						message: '考试时间未到！',
					})
					return;
				}
				if(nowTime > endTime) {
					this.$message({
						type: 'info',
						message: '考试时间已结束！',
					})
					return;
				}
				this.$router.push({
					name: 'examineinfo',
					query: {
						id: item.id
					}
				})
			},
			examineit(item) {
				this.$router.push({
					name: 'examdetails',
					query: {
						id: item.id
					}
				})
			},
		},
		beforeDestroy() {
			window.onfocus = function() {}
		},
	}
</script>